var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-1",staticStyle:{"width":"100%","text-align":"center"}},[(_vm.itemImg != null && _vm.itemImg != '')?_c('img',{staticClass:"mt-1 img-upload-admin",staticStyle:{"max-height":"50px"},attrs:{"src":_vm.core.baseUrl() + _vm.itemImg}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }